/* eslint-disable camelcase */
import { fetchList as lockerSizeFetchList } from '@/api/lockerSize'
import { fetchList as lockerStatusFetchList } from '@/api/lockerStatus'
import { fetchList as centerFetchList , ownCenterList as ownCenterFetchList } from '@/api/center'

const state = {
  lockerStatusList: [],
  lockerSizeList: [],
  lockerList: [],
}

const mutations = {
  SET_STATUSLIST: (state, list) => {
    state.lockerStatusList = list
  },
  SET_SIZELIST: (state, list) => {
    state.lockerSizeList = list
  },
  SET_LOCKERLIST: (state, list) => {
    state.lockerList = list
  },

}

const actions = {

  sizeList({ commit }, parameter) {
    console.log('inside sizeList', { parameter })

    return new Promise(resolve => {
      lockerSizeFetchList(parameter).then(lockerSizeResponse => {
        console.log('lockerSizeResponse', lockerSizeResponse)

        // setMenu(lockerSizeResponse.items)
        commit('SET_SIZELIST', lockerSizeResponse.data.items)
        resolve(lockerSizeResponse.data)
      }).catch(err => {
        console.log('lockerSizeResponse err', err)
      })

      // setMenu(menus)
      // commit('SET_MENUS', menus)
      // resolve(menus)
    }).catch(error => {
      console.log('error', error)

      // reject(error)

      // alert('Login failed. Please contact JobTotal Administrator.')
    })
  },

  statusList({ commit }, parameter) {
    console.log('store list parameter', { parameter })

    return new Promise(resolve => {
      lockerStatusFetchList(parameter).then(lockerStatusResponse => {
        console.log('lockerStatusResponse', lockerStatusResponse)

        //  setMenu(menus)
        // commit('SET_MENUS', menus)
        commit('SET_STATUSLIST', lockerStatusResponse.data.items)
        resolve(lockerStatusResponse.data)
      })
    }).catch(error => {
      console.log('error', error)

      // reject(error)

      // alert('Login failed. Please contact JobTotal Administrator.')
    })
  },

  lockerList({ commit }, parameter) {
    console.log('center list parameter', { parameter })

    return new Promise((resolve, reject) => {
      ownCenterFetchList(parameter).then(Response => {
        console.log('lockerStatusResponse', Response)

        //  setMenu(menus)
        // commit('SET_MENUS', menus)
        commit('SET_LOCKERLIST', Response.data.items)
        resolve(Response.data)
      })
    }).catch(error => {
      console.log('error', error)

      // reject(error)

      // alert('Login failed. Please contact JobTotal Administrator.')
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
